module.exports = __webpack_public_path__ + "img/mushaModal.d68bc31d.png";